/* eslint-disable */
import * as Yup from "yup";
import Validators from "../../utils/validatorsHelper";

export const DefesaCivilValidationSchema = Yup.object().shape({
    qtdeEntradaSaida: Yup.number()
        .min(1, 'Quantidade não deve ser inferior a 1')
        .required('Campo obrigatório')
});

export const RegistroValidationSchema = Yup.object().shape({
    tipoEstoque: Yup.string().required("Campo obrigatório"),
    numero: Yup.string().required("Campo obrigatório").when(['tipoEstoque'], {
		is: tipoEstoque => tipoEstoque === 'ARP',
		then: Yup.string().test('numero', 'Campo obrigatório', (value) => {
			if (value) {
				return value.match(/\d{4}([/])\d{4,1000}/g);
			}
			return false;
		})
	}),
    qtdeEntradaSaida: Yup.number().min(1, 'Quantidade não deve ser inferior a 1').required("Campo obrigatório"),
    valorUnitario: Yup.string().required('Campo obrigatório').test('valorUnitario', 'Valor deve ser maior que R$0,00', (value) => {
		const double = value ? value.replace(/[^\d\+]/g, '') : null;
		if (double) {
			return Number(double) > 0;
		}
		return false;
	}),

    /* 
        Campos validados apenas se o tipo de estoque for ARP
    */
    validade: Yup.string().when(['tipoEstoque'], {
        is: tipoEstoque => tipoEstoque === 'ARP',
        then: Yup.string().required('Campo obrigatório'),
    }),
    crepdecsForm: Yup.array().when(['tipoEstoque'], {
        is: tipoEstoque => tipoEstoque === 'ARP',
        then: Yup.array().min(1, 'Selecione pelo menos uma CREPDEC').required('Campo obrigatório'),
    }),

    empresa: Yup.object().shape({
        nome: Yup.string().trim().required("Campo obrigatório"),
        cnpj: Yup.string()
            .test("cnpj", "CNPJ inválido", val => {
                if (val === undefined) {
                    return false;
                }
                return Validators.validarCNPJ(val);
            })
            .required("Campo obrigatório"),
        email: Yup.string()
            .test("email", "Informe um e-mail válido", val => {
                return Validators.validarEmail(val);
            })
            .required("Campo obrigatório"),
        telefonePrincipal: Yup.string()
            .test("telefonePrimario", "Informe um telefone válido", val => {
                return Validators.validarTelefone(val);
            })
            .required("Campo obrigatório"),
        telefoneSecundario: Yup.string().test(
            "telefoneSecundario",
            "Informe um telefone válido",
            val => {
                return Validators.validarTelefone(val);
            }
        ),
        endereco: Yup.object().shape({
            municipio: Yup.object().shape({
                codigoIbge: Yup.number()
                    .min(1, "Campo obrigatório")
                    .required("Campo obrigatório")
            }),
            cep: Yup.string().required("Campo obrigatório"),
            bairro: Yup.string().trim().required("Campo obrigatório"),
            logradouro: Yup.string().trim().required("Campo obrigatório"),
            numero: Yup.string().trim().required("Campo obrigatório")
        })
    })
}, [['tipoEstoque', 'validade'], ['tipoEstoque', 'crepdecsForm']]);

export const MovimentacaoValidationSchema = Yup.object().shape({
    quantidade: Yup.number().min(1, 'Quantidade não deve ser inferior a 1').required("Campo obrigatório"),
    recebedor: Yup.string().trim().required("Campo obrigatório"),
    destino: Yup.object().shape({
        id: Yup.string().required("Campo obrigatório")
    }),
    origem: Yup.object().shape({
        id: Yup.string().required("Campo obrigatório")
    })
});
